import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=53770cd3&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"
import style0 from "./Articles.vue?vue&type=style&index=0&id=53770cd3&prod&lang=scss"
import style1 from "./Articles.vue?vue&type=style&index=1&id=53770cd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53770cd3",
  null
  
)

export default component.exports